export default __webpack_public_path__ + "static/media/hands-grip.0ce10f18.svg";